<template>
  <div class="page">
    <app-title :page="'Settings'">
      <div
        slot="content"
        class="flex justify-content-space-between flex-end">
        <p class="font-size-4 mb2">Configure your organization.</p>
      </div>
    </app-title>

    <section class="grid grid-columns-2_sm grid-columns-3_md vh33 mb-margin">
      <app-organization
        v-if="!organizationLoading && organization.owner === user.id"
        :class="'grid-column-span-2_sm grid-column-span-1_md'"/>
      <app-roles v-if="!rolesLoading"/>
      <app-team v-if="!teamLoading"/>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Organization from './Organization'
import Roles from './Roles'
import Team from './Team'
import page from '../mixins/page'

export default {
  components: {
    appOrganization: Organization,
    appRoles: Roles,
    appTeam: Team
  },
  mixins: [ page ],
  computed: {
    ...mapGetters([
      'user',
      'organization',
      'rolesLoading',
      'teamLoading'
    ])
  }
}
</script>
